import { Component } from '@angular/core';
import { faCheck, faCircle, faExclamation, faInfo } from '@fortawesome/pro-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { FaStackComponent, FaIconComponent, FaStackItemSizeDirective } from '@fortawesome/angular-fontawesome';
import { NgClass } from '@angular/common';

type ToastType = 'success' | 'error' | 'warning' | 'info';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  imports: [NgClass, FaStackComponent, FaIconComponent, FaStackItemSizeDirective, TranslateModule],
})
export class ToastComponent {
  message = '';
  isVisible = false;
  faCircle = faCircle;
  toastIcon!: any;
  animationClass = '';
  toastType: ToastType = 'info';

  show(message: string, type: ToastType = 'info', duration = 5000) {
    this.message = message;
    this.toastType = type;
    this.toastIcon = this.getToastIcon(type);

    this.isVisible = true;
    this.animationClass = '';

    setTimeout(() => {
      this.animationClass = 'show';
    }, 50);

    setTimeout(() => this.hide(), duration);
  }

  hide() {
    this.animationClass = 'hide';

    setTimeout(() => {
      this.isVisible = false;
      this.animationClass = '';
    }, 800);
  }

  close() {
    this.hide();
  }

  private getToastIcon(type: ToastType): any {
    switch (type) {
      case 'success':
        return faCheck;
      case 'error':
        return faExclamation;
      case 'warning':
        return faExclamation;
      case 'info':
      default:
        return faInfo;
    }
  }
}
